// 使用axios
import axios from 'axios';
import store from "../store";
const service = axios.create({
    // 公共接口--这里注意后面会讲
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 30000  //响应时间
});

service.interceptors.request.use(
    config => {
        config.headers.common = {
            'Access-Control-Allow-Origin': '*'
        }
        let token = localStorage.getItem('access_token')
        // console.log('11:'+token);
        if (token) {
            config.headers.Authorization = token
        }
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);
service.interceptors.response.use(
    res => {
        // 判断一下响应中是否有 token，如果有就直接使用此 token 替换掉本地的 token。你可以根据你的业务需求自己编写更新 token 的逻辑
        var token = res.headers.authorization;
        if (token) {
            // 如果 header 中存在 token，那么触发 refreshToken 方法，替换本地的 token
            store.commit('refreshToken', token)
        }
        if (res.status === 200) {
            return res.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);
export default service;
